import { Menu, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DeleteIcon from "../../Icons/DeleteIcon";
import MarkIcon from "../../Icons/MarkIcon.tsx";
const ActionModal = (props: any) => {
  const { handleDelete, handleRead, row } = props;
  return (
    <div>
      <Menu as="div" className={tw`relative inline-block text-left `}>
        <div>
          <Menu.Button
            className={tw`shadow-md w-6 rounded-full focus:outline-none`}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                stroke="#0D0D0D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                stroke="#0D0D0D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                stroke="#0D0D0D"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={tw`absolute right-7 z-50  top-0 mt-2 w-60 origin-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          >
            <div className="px-2 py-4  flex flex-col gap-2">
              <Menu.Item>
                <button
                  className={tw`cursor-pointer px-2 flex gap-x-2 border-b focus:outline-none`}
                  onClick={() =>
                    handleRead(row?.original?.id, row?.original?.unread)
                  }
                >
                  <MarkIcon />
                  {row?.original?.unread ? "Mark as Read" : "Mark as Unread"}
                </button>
              </Menu.Item>
              <Menu.Item>
                <button
                  className={tw`cursor-pointer px-2 flex gap-x-2 focus:outline-none`}
                  onClick={() => handleDelete(row?.original?.id)}
                >
                  <DeleteIcon />
                  Remove this notification
                </button>
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default ActionModal;
